import { render, staticRenderFns } from "./PayrollHistory.vue?vue&type=template&id=2942a6e7&scoped=true"
import script from "./PayrollHistory.vue?vue&type=script&lang=js"
export * from "./PayrollHistory.vue?vue&type=script&lang=js"
import style0 from "./PayrollHistory.vue?vue&type=style&index=0&id=2942a6e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2942a6e7",
  null
  
)

export default component.exports